export default __webpack_public_path__ + "static/media/404.d5006257.png";